import { AddAlertOutlined } from '@mui/icons-material';
import { useRouter } from 'next/router';
import { NeedsAttentionCard } from '@/views/Home/components/NeedsAttention/components/NeedsAttentionCard';
import type { CoreRequest } from '$api-clients/hooks';

type Props = {
  interactions: CoreRequest<'/interactions'>['Data']['results'][number]['interaction'][];
  interactionCount: number;
};

export function BuyerAgreementsExpiringSoon({
  interactionCount = 0,
  interactions = [],
}: Props) {
  const router = useRouter();

  const supplementaryDetails: string[] = [
    'Buyer agreement end date is within a week',
  ];

  const handleClick = () => {
    if (interactionCount > 1) {
      void router.push(`/buyers`);
    } else {
      void router.push(`/buyers/${interactions[0]?.id}/buyer-agreement`);
    }
  };

  return (
    <NeedsAttentionCard
      itemCount={interactionCount}
      color="warning"
      headerStartAdornment={<AddAlertOutlined />}
      onClick={handleClick}
      supplementaryDetails={supplementaryDetails}
      title="Buyer Agreements Expiring Soon"
    />
  );
}

BuyerAgreementsExpiringSoon.displayName = 'BuyerAgreementsExpiringSoon';
